import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnInit,
} from '@angular/core';
import {
  AbstractControl,
  FormGroupDirective,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { MatFormFieldAppearance } from '@angular/material/form-field';

@Component({
  selector: 'rd-anz-enrollment-link-account-detail-form',
  templateUrl: './link-account-detail-form.component.html',
  styleUrls: ['./link-account-detail-form.component.scss'],
  // Doing this so that the parent component can mark this form as touched
  // and validation errors will work
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ANZEnrollmentLinkAccountDetailFormComponent implements OnInit {
  @HostBinding('class.rd-rcv2-enrollment-link-account-detail-form')
  componentClass = true;

  @Input() formGroupName: string;

  matFormFieldAppearance: MatFormFieldAppearance = 'outline';
  accountDetailForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private rootFormGroup: FormGroupDirective,
  ) {}

  ngOnInit(): void {
    this.accountDetailForm = this.rootFormGroup.control.get(
      this.formGroupName,
    ) as UntypedFormGroup;
  }

  get isAccountFirstNameEmpty(): boolean {
    return (
      this.accountDetailForm.get('accountFirstName') as AbstractControl
    ).hasError('required');
  }

  get isAccountLastNameEmpty(): boolean {
    return (
      this.accountDetailForm.get('accountLastName') as AbstractControl
    ).hasError('required');
  }

  get isBsbNumberEmpty(): boolean {
    return (
      this.accountDetailForm.get('bsbNumber') as AbstractControl
    ).hasError('required');
  }

  get isAccountNumberEmpty(): boolean {
    return (
      this.accountDetailForm.get('accountNumber') as AbstractControl
    ).hasError('required');
  }

  get isAccountFirstNameInvalidPattern(): boolean {
    return (
      this.accountDetailForm.get('accountFirstName') as AbstractControl
    ).hasError('pattern');
  }

  get isAccountLastNameInvalidPattern(): boolean {
    return (
      this.accountDetailForm.get('accountLastName') as AbstractControl
    ).hasError('pattern');
  }

  get isBsbNumberInvalidPattern(): boolean {
    return (
      this.accountDetailForm.get('bsbNumber') as AbstractControl
    ).hasError('pattern');
  }

  get isAccountNumberInvalidPattern(): boolean {
    return (
      this.accountDetailForm.get('accountNumber') as AbstractControl
    ).hasError('pattern');
  }
}
